import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';
import { withStyles } from '@material-ui/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Scrollbar from 'react-custom-scrollbars';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Radio from '@material-ui/core/Radio';
import { IconButton } from '@material-ui/core';
import { LoadingIndicator, Button } from '../../components';
import { ThemeColors } from '../../theme';
import remHtml from '../../util/removeHtml';

const AntTabs = withStyles({
  root: {
    margin: 20,
  },
})(Tabs);


const AntTab = withStyles(theme => ({
  root: {
    textTransform: 'none',
    color: theme.palette.primary.main,
    minWidth: 72,
    fontWeight: 'bold',
    marginRight: 10,
    '&:hover': {
      borderBottom: `5px solid ${theme.palette.secondary.main}`,
      opacity: 1,
    },
    '&$selected': {
      borderBottom: `5px solid ${theme.palette.secondary.main}`,
    },
    '&:focus': {
      borderBottom: `5px solid ${theme.palette.secondary.main}`,
    },
  },
  selected: {
    borderBottom: `5px solid ${theme.palette.secondary.main}`,
  },
}))(props => <Tab disableRipple {...props} />);


class ContentPicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: 'courses',
    };
  }

  isSelected = (id, type) => this.state.linkedContentId === id &&
  this.state.linkedContentType === type;

  handlePannelOpen = (pannelId, item) => {
    const openPannel = this.state.pannelId !== pannelId;

    if (openPannel && item.type === 'course') {
      this.props.loadCourseCards({...item, includeAll: true });
    } else if (openPannel && item.type === 'test') {
      this.props.loadQuestions(item);
    }


    this.setState({
      openPannel: this.state.openPannel === pannelId ? null : pannelId,
    });
  }

  handleChangeTab = (event, tab) => {
    this.setState({
      selectedTab: tab,
    });
  }

  handleLoadCourseCard = (course) => {
    this.props.loadCourseCards(course);
  }

  handleSelectItem = (id, type, name, parentId) => {
    if (this.state.linkedContentId === id && this.state.linkedContentType === type) {
      this.setState({ linkedContentId: null, linkedContentType: '', linkedContentName: '', parentId: null });
    } else {
      this.setState({
        linkedContentId: id,
        linkedContentType: type,
        linkedContentName: name,
        parentId });
    }
  }

  handleSaveSelectItem = (id, type) => {
    if (!this.state.linkedContentId || !this.state.linkedContentType) return null;

    this.setState({
      linkedContentId: id,
      linkedContentType: type,
    });
    return null;
  }

  renderImage = (img) => {
    if (!img) return null;

    return <img alt="content" src={img} style={{ width: 50, height: 50 }} />;
  }

  renderExpandedArea = (pannelId, child) => {
    if (this.state.openPannel !== pannelId) return null;

    return (<div
      style={{
        padding: 5,

      }}
    >
      {this.renderExpandedContent(child.type)}
    </div>);
  }

  renderCard = card => (
    <div
      style={{
        marginTop: 5,
        marginBottom: 5,
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: '#F5F5F5 1px solid',
        alignItems: 'center',
        fontWeight: 600,
      }}
    >
      <Typography style={{ color: ThemeColors.primary1Color }}>{card.title}</Typography>
      <Radio
        color="primary"
        onClick={() => this.handleSelectItem(card.id, 'Card', card.title, card.courseId)}
        checked={this.isSelected(card.id, 'Card')}
      />
    </div>
    )

  renderQuestion = question => (
    <div
      style={{
        marginTop: 5,
        marginBottom: 5,
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: '#F5F5F5 1px solid',
        alignItems: 'center',
        fontWeight: 600,
      }}
    >
      <Typography style={{ color: ThemeColors.primary1Color }}>{remHtml(question.text)}</Typography>
      <Radio
        color="primary"
        checked={this.isSelected(question.id, 'Question', remHtml(question.text), question.testId)}
        onClick={() => this.handleSelectItem(question.id, 'Question')}
      />
    </div>
    )

  renderExpandedContent = (type) => {
    if (this.props.isLoadingCards || this.props.isLoadingQuestions) {
      return <LoadingIndicator />;
    }

    if (type === 'course') {
      if (!this.props.cards) return null;

      return this.props.cards.map(c => this.renderCard(c));
    }

    if (type === 'test') {
      if (!this.props.questions) return null;

      return this.props.questions.map(c => this.renderQuestion(c));
    }

    return null;
  }


  renderChild = (child) => {
    const { classes } = this.props;
    const childId = `${child.type}${child.id}`;

    const expandIcon = this.state.openPannel === childId
      ? (<ExpandLessIcon />)
      : (<ExpandMoreIcon />);

    return (
      <div
        style={{
          marginBottom: 10,
          border: '#F5F5F5 1px solid',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <div
            style={{ display: 'flex', cursor: 'pointer' }}
            onClick={() => this.handlePannelOpen(childId, child)}
          >
            <div
              style={{
                height: 80,
                backgroundSize: 'contain',
                width: 80,
                minWidth: 80,
                marginRight: 10,
                backgroundImage: `url(${child.imageUrl})` }}
            />

            {/* {this.renderImage(child.imageUrl)} */}
            <Typography className={classes.childTitleStyle}>{child.name}</Typography>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'flex-end',
              justifyContent: 'space-between',
            }}
          >
            <IconButton
              style={{ padding: 9 }}
              onClick={() => this.handlePannelOpen(childId, child)}
            >
              {expandIcon}
            </IconButton>

            <Radio
              color="primary"
              checked={this.isSelected(
                child.id,
                child.type.charAt(0).toUpperCase() + child.type.slice(1),
              )}
              onClick={() =>
              this.handleSelectItem(
                child.id,
                child.type.charAt(0).toUpperCase() + child.type.slice(1),
                child.name,
                )}
            />
          </div>
        </div>
        {this.renderExpandedArea(childId, child)}
      </div>
    );
  }


  renderGroup = (group) => {
    const { classes } = this.props;
    if (!group.children) return null;
    return (
      <div>
        <Typography className={classes.groupTitle}>{group.name}</Typography>
        {group.children.map(c => this.renderChild(c))}
      </div>
    );
  }

  renderGroups = groups => (groups.map(g => this.renderGroup(g)))

  renderContent() {
    const topLevelCourses = this.props.courseGroups.filter(c => c.type === 'course');
    const courseData = this.props.courseGroups.asMutable().filter(t => t.type === 'group' && t.children && t.children.length);
    courseData.push({ name: 'Weitere Inhalte', children: topLevelCourses });


    const topLevelTests = this.props.testGroups.filter(c => c.type === 'test');
    const testData = this.props.testGroups.asMutable().filter(t => t.type === 'group' && t.children && t.children.length);
    testData.push({ name: 'Weitere Inhalte', children: topLevelTests });

    if (this.state.selectedTab === 'courses') {
      return this.renderGroups(courseData);
    }

    return this.renderGroups(testData);
  }

  render() {
    const { onClose, open } = this.props;
    if (!this.props.courseGroups || !this.props.testGroups) return null;


    const buttonStyle = {
      width: '100%',
      textTransform: 'none',
      color: 'white',
      borderRadius: 2,
    };

    return (
      <Popover
        open={open}
        anchorEl={open}
        onClose={onClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        PaperProps={{
          style: { borderRadius: 10 },
        }}
      >
        <div>
          <Scrollbar style={{ padding: 20, width: 450, height: 600 }}>
            <AntTabs
              value={this.state.selectedTab}
              onChange={this.handleChangeTab}
              aria-label="ant example"
            >
              <AntTab label="Inhalte" value="courses" />
              <AntTab label="Test" value="tests" />
            </AntTabs>
            <div style={{ padding: 20 }}>
              {this.renderContent()}
            </div>
          </Scrollbar>
          <Button
            label="Auswählen"
            disabled={!this.state.linkedContentId}
            onClick={() => {
              this.props.onClose();
              this.props.saveSelection(
                this.state.linkedContentId,
                this.state.linkedContentType,
                this.state.linkedContentName,
                this.state.parentId,
                );
            }
              }
            color="secondary"
            variant="contained"
            style={buttonStyle}
          />
        </div>
      </Popover>
    );
  }
}

ContentPicker.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  loadCourseCards: PropTypes.func,
  loadQuestions: PropTypes.func,
  classes: PropTypes.object.isRequired,
  isLoadingCards: PropTypes.bool,
  isLoadingQuestions: PropTypes.bool,
  cards: PropTypes.array,
  questions: PropTypes.arra,
  courseGroups: PropTypes.array,
  testGroups: PropTypes.array,
  saveSelection: PropTypes.func,
};

ContentPicker.defaultProps = {
  loadCourseCards: () => {},
  loadQuestions: () => {},
  isLoadingCards: false,
  isLoadingQuestions: () => {},
  cards: [],
  questions: [],
  courseGroups: [],
  testGroups: [],
  saveSelection: () => {},
};

const styles = theme => ({
  groupTitle: {
    fontSize: 16,
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  childTitleStyle: {
    color: theme.palette.primary.main,
    fontSize: 14,
    fontWeight: 'bold',
    marginTop: 10,
  },
});

export default withStyles(styles)(ContentPicker);



// WEBPACK FOOTER //
// ./src/app/main/socialwall/content-picker.js